export default {
  list: [
    {
      title: 'مرد',
      value: 'MALE'
    },
    {
      title: 'زن',
      value: 'FEMALE'
    },
  ],
  values: {
    MALE: 'MALE',
    FEMALE: 'FEMALE'
  }
};
